import React, { useState } from 'react'
import Label from '../../../../components/label/Label'
import Button from '../../../../components/button/Button'
import TextInput from '../../../../components/input/textinput/TextInput'
import { BUTTON_TYPE } from '../../../../components/button/constants'
import Heading from '../../../../components/heading/Heading'
import { HEADING } from '../../../../components/heading/constants/constants'
import styles from './ApiInformation.styles'
import { useDispatch, useSelector } from 'react-redux'
import { componentKey } from '../../ApiSlice'
import { LABEL_WEIGHT } from '../../../../components/label/constants'
import Loadable from '../../../../components/loadable/Loadable'
import PageBody from '../../../../components/pagebody/PageBody'
import ChangePlan from '../../../components/changeplan/ChangePlan'
import Icons from '../../../../components/icons/Icons'
import { VEC_ICON_NAME } from '../../../../components/icons/constants'
import { API_HUB_LOADING_STATES_MESSAGE_MAP, PAGE_STATE, PAGE_STATE_MESSAGE_MAP } from '../../../constants/constants'
import { USER_PLAN_NAME } from '../../../../../libs/customhooks/constants'
import Config from '../../../../config.web'
import { ENVIRONMENTS } from '../../../constants/constants'
import { API_HUB_LOADING_STATES } from '../../../constants/constants'
import { disableApi, requestProductionKey } from '../../ApiSaga'

export default function ApiInformation() {
	const { loadingState, isRequestedProductionAppKey, sandBoxAppKey, productionAppKey, showProdAppKey, apiPortalLoginUrl, sandBoxApplicationUrl, userType, shouldProductionKeyRequestManually } = useSelector((state) => state[componentKey])
	const [sandboxCopyText, setSandboxCopyText] = useState('COPY')
	const [productionCopyText, setProductionCopyText] = useState('COPY')
	const [showChangePlanPopup, setShowChangePlanPopup] = useState(false)
	const [showNewTabIconForDeveloperHub, setShowNewTabIconForDeveloperHub] = useState(false)
	const [showNewTabIconForSandbox, setShowNewTabIconForSandbox] = useState(false)
	
	const dispatch = useDispatch();

	const handleClipboardCopy = (key) => {
		switch (key) {
			case 'SANDBOXKEY':
				navigator.clipboard.writeText(sandBoxAppKey)
				setSandboxCopyText('COPIED')
				setTimeout(() => {
					setSandboxCopyText('COPY')
				}, [2000])
				break;
			case 'PRODUCKEY':
				navigator.clipboard.writeText(productionAppKey)
				setProductionCopyText('COPIED')
				setTimeout(() => {
					setProductionCopyText('COPY')
				}, [2000])
				break;
		}
	}

	const requestProductionKeyOption = () => {
		if(userType === 3 && productionAppKey !== ""){
			return <>
				<div style={styles.optionLeftColumn}>
					<Label>App Key</Label>
				</div>
				<div style={styles.optionRightColumn}>
					<TextInput disabled={true} value={productionAppKey}>
						<Button type={BUTTON_TYPE.LIGHT_WITH_NO_BORDER} onClickCb={() => handleClipboardCopy('PRODUCKEY')}>{productionCopyText}</Button>
					</TextInput>
				</div>

			</>
		}
		else if(userType === 3 && productionAppKey === "" && !isRequestedProductionAppKey && !shouldProductionKeyRequestManually){
			return <div>
				<Heading type={HEADING.H3}>Request Production App Key</Heading>
				<div style={styles.optionRow}>
					<div style={styles.fullWidthButton}>
						<Loadable currentState={loadingState.state} loadingStates={[API_HUB_LOADING_STATES.REQUEST_PROD_KEY_LOADING]} messageMap={API_HUB_LOADING_STATES_MESSAGE_MAP} isNewLoadable={true} isFullWidth={false}>
							<Button type={BUTTON_TYPE.PRIMARY} onClickCb={() => dispatch(requestProductionKey())}>Request Production Key</Button>
						</Loadable>
					</div>
				</div>
			</div>
		}else if(userType === 3 && productionAppKey === "" && isRequestedProductionAppKey && !shouldProductionKeyRequestManually){
			return <Label weight={LABEL_WEIGHT[700]}>We have received your request. Our sales team will reach out to you shortly.</Label>
		}else if(userType === 3 && productionAppKey === "" && shouldProductionKeyRequestManually){
			return <Label weight={LABEL_WEIGHT[700]}>You will have to reach out to our sales team to enable the production key.</Label>
		}else{
			return <div style={styles.fullWidthButton}>
				<Button type={BUTTON_TYPE.PRIMARY} onClickCb={() => setShowChangePlanPopup(true)}>REQUEST API</Button>
				<Label customStyles={styles.red} weight={LABEL_WEIGHT[700]}>Please Note: Upgrade to Enterprise is required for API use</Label>
			</div>
		}
	}

	return (
		<Loadable currentState={loadingState.state} loadingStates={PAGE_STATE.LOADING} messageMap={PAGE_STATE_MESSAGE_MAP} isNewLoadable={true}>
				<div style={styles.body}>
					<div>
						<Heading type={HEADING.H3}>Sandbox</Heading>
						<div style={styles.optionRow}>
							<div style={styles.optionLeftColumn}>
								<Label>App Key</Label>
							</div>
							<div style={styles.optionRightColumn}>
								<TextInput disabled={true} value={sandBoxAppKey}>
									<Button type={BUTTON_TYPE.LIGHT_WITH_NO_BORDER} onClickCb={() => handleClipboardCopy('SANDBOXKEY')}>{sandboxCopyText}</Button>
								</TextInput>
							</div>
						</div>
					</div>
					<div>
						<Heading type={HEADING.H3}>Information</Heading>
						<div style={styles.optionRow}>
							<div style={styles.optionLeftColumn}>
								<Label>Sandbox Application</Label>
							</div>
							<div style={styles.optionRightColumn}>
								<div onMouseEnter={() => setShowNewTabIconForSandbox(true)} onMouseLeave={() => setShowNewTabIconForSandbox(false)} style={{...styles.linkDiv, ...styles.linkBlue}} onClick={() => window.open(sandBoxApplicationUrl, "_blank", "noopener,noreferrer")}>
									{new URL(sandBoxApplicationUrl).host}
									{ showNewTabIconForSandbox && <Icons familyName={'vec'} iconName={VEC_ICON_NAME.NEW_TAB_ICON} style={styles.linkBlue} />}
								</div>
							</div>
						</div>
						<div style={styles.optionRow}>
							<div style={styles.optionLeftColumn}>
								<Label>Develop Hub</Label>
							</div>
							<div style={styles.optionRightColumn}>
								<div onMouseEnter={() => setShowNewTabIconForDeveloperHub(true)} onMouseLeave={() => setShowNewTabIconForDeveloperHub(false)} style={{...styles.linkDiv, ...styles.linkBlue}} onClick={() => window.open(apiPortalLoginUrl, "_blank", "noopener,noreferrer")}>
									apideveloper.tax1099.com
									{ showNewTabIconForDeveloperHub && <Icons familyName={'vec'} iconName={VEC_ICON_NAME.NEW_TAB_ICON} style={styles.linkBlue} />}
								</div>
							</div>
						</div>
					</div>

					{
						(Config.ENV === ENVIRONMENTS.DEV) ? <div>
							<Heading type={HEADING.H3}>Production</Heading>
							<div style={styles.optionRow}>
								{requestProductionKeyOption()}
							</div>

						</div>
						: null
					}
					{
						(Config.ENV !== ENVIRONMENTS.STAGE) ? <div>
							<Heading type={HEADING.H3}>Remove API Access</Heading>
							<div style={styles.optionRow}>
								<div style={styles.fullWidthButton}>
									<Loadable currentState={loadingState.state} loadingStates={[API_HUB_LOADING_STATES.DISABLE_API_LOADING]} messageMap={API_HUB_LOADING_STATES_MESSAGE_MAP} isNewLoadable={true} isFullWidth={false}>
										<Button type={BUTTON_TYPE.PRIMARY} onClickCb={() => {dispatch(disableApi())}}>Disable API Key</Button>
									</Loadable>
								</div>
							</div>

						</div>
						: null
					}

				</div>
				{showChangePlanPopup && <ChangePlan closePopup={() => setShowChangePlanPopup(false)} showPopup={showChangePlanPopup} disabledPlans={[USER_PLAN_NAME.ESSENTIAL_USER, USER_PLAN_NAME.EFILE_PLUS_USER]}/>}
		</Loadable>
	)
}